@if (reportModel; as model) {
  <app-report-header i18n-header header="Picking List" [model]="model.sellingCompany"></app-report-header>
  <app-report-header-details
    i18n-addressTitle
    i18n-additionalAddressTitle
    addressTitle="Account Address"
    additionalAddressTitle="Delivery Address"
    [address]="model.customerAddress"
    [additionalAddressee]="model.deliveryAddressee"
    [additionalAddress]="
      model.deliveryAddress ? model.deliveryAddress : model.printDeliveryAddress ? model.customerAddress : ''
    "
    [summaryItems]="pickingListSummaryItems(model)"
  ></app-report-header-details>
  @if (!model.pickingListWarehouses[0].holdStockAtProductLevel) {
    <app-report-table
      [model]="model.pickingListWarehouses[0].salesOrderLines"
      [footerModel]="model"
      [bodyColumns]="lineColumns.bind(this)"
      bodySubTableColumnsProperty="pickingListAllocations"
      [bodySubTableColumns]="lineSubTableColumns"
      [extraBoldLine]="true"
    ></app-report-table>
  }
  @if (model.pickingListWarehouses[0].holdStockAtProductLevel) {
    <app-report-table
      [model]="model.pickingListWarehouses"
      [footerModel]="model"
      [bodyColumns]="lineColumnsWarehouse.bind(this)"
      bodySubTableColumnsProperty="salesOrderLines"
      [bodySubTableColumns]="lineSubTableColumnsWarehouse"
    ></app-report-table>
  }
  <app-report-table
    i18n-header
    header="Extra Items"
    [model]="model.salesOrderExtraItems"
    [bodyColumns]="extraColumns.bind(this)"
  ></app-report-table>
  <app-report-value-pairs [summaryItems]="footerSummaryItems(model)"></app-report-value-pairs>
  <app-report-footer [model]="model.sellingCompany"></app-report-footer>
}
